import { render, staticRenderFns } from "./amsterdam.vue?vue&type=template&id=5ec6dc3e"
import script from "./amsterdam.vue?vue&type=script&lang=js"
export * from "./amsterdam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports